import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/react-hooks'
import { useHistory, useLocation } from 'react-router-dom'
import ReactSVG from 'react-svg'
import classNames from 'classnames'

import checkIcon from '../../../../images/forms-check-white.svg'
import addIcon from '../../../../images/add-to-list.svg'
import WATCHLISTS_FOR_CONTENT_QUERY from '../../../../graphql/queries/watchlists-for-content.gql'
import { E2E_SELECTORS } from '../../../e2e-selectors'
import { useIsAuthenticated } from '../../../hooks/use-is-authenticated'
import { getModalLocation } from '../../../lib/modal'
import { MODALS } from '../../../constants'
import Button from '../../button'
import styles from './add-or-remove-from-list.css'

/**
 * Displays the show-page watchlist button and opens either the login modal or
 * the authenticated list-management modal when selected.
 */
function AddOrRemoveFromListButton({
  contentItem,
  renderedInComponent
}) {
  const history = useHistory()
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()
  const { data: watchlistsData } = useQuery(WATCHLISTS_FOR_CONTENT_QUERY, {
    skip: !isAuthenticated,
    variables: {
      contentItemId: contentItem.id
    },
    fetchPolicy: 'cache-first'
  })
  const watchlistsForContent = isAuthenticated
    ? watchlistsData?.watchlistsForContent ?? []
    : []
  const contentIsOnList = watchlistsForContent.some(watchlist => watchlist.hasContent)
  const buttonIcon = contentIsOnList ? checkIcon : addIcon

  const openAddToListsModal = event => {
    event.preventDefault()

    if (!isAuthenticated) {
      history.push(getModalLocation(location, MODALS.qsParams.login))
      return
    }

    history.push(getModalLocation(
      location,
      MODALS.qsParams.addContentToLists,
      {
        contentItemId: contentItem.id,
        renderedInComponent
      },
      {
        contentItem
      }
    ))
  }

  return (
    <div className={styles.container}>
      <Button
        className={styles.addOrRemoveFromListButton}
        onClick={openAddToListsModal}
        e2eIdentifier={E2E_SELECTORS.ADD_REMOVE_FROM_MY_LIST_BUTTON}
        isRental={contentItem.isRental}
        darkBGSecondary
      >
        <ReactSVG
          src={buttonIcon}
          beforeInjection={(svg) => {
            svg.setAttribute('class', classNames(
              styles.addOrRemoveFromListIcon,
              {
                [styles.checkIconStyle]: contentIsOnList
              }
            ))
          }}
        />
      </Button>

      <span className={styles.cta}>
        Add To List
      </span>
    </div>
  )
}

AddOrRemoveFromListButton.propTypes = {
  contentItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isRental: PropTypes.bool,
    __typename: PropTypes.string
  }).isRequired,
  renderedInComponent: PropTypes.string.isRequired
}

export default AddOrRemoveFromListButton
